import React, { useEffect } from "react";
import { MdArrowOutward } from "react-icons/md";

const ARTICLES = [
    {
        id: 1,
        tag: "Observability",
        title: "Understanding Azure Monitor: Metrics vs. Logs",
        excerpt:
            "Azure Monitor provides two fundamental data types — Metrics and Logs. Choosing between them, and knowing when to combine both, is essential for building effective monitoring pipelines that catch issues before they escalate.",
        date: "Mar 2025",
        readTime: "5 min read",
        href: "#",
    },
    {
        id: 2,
        tag: "Reliability",
        title: "Root Cause Analysis in Enterprise Cloud Environments",
        excerpt:
            "Effective RCA is not just about finding what broke — it's about understanding why, and building safeguards to prevent recurrence. This note covers the structured approach I follow for incident analysis using Azure Log Analytics.",
        date: "Feb 2025",
        readTime: "7 min read",
        href: "#",
    },
    {
        id: 3,
        tag: "Development",
        title: "Getting Started with Application Insights Telemetry",
        excerpt:
            "Application Insights goes beyond uptime monitoring. From dependency tracking to custom events and exceptions, here's how to instrument your application and extract meaningful signals from the data.",
        date: "Jan 2025",
        readTime: "6 min read",
        href: "#",
    },
    {
        id: 4,
        tag: "Cost",
        title: "Azure Cost Management: Finding and Eliminating Waste",
        excerpt:
            "Cloud costs can spiral quickly without proper governance. This article walks through the tagging strategy, cost analysis queries, and alerting rules I use to maintain visibility and control over Azure spending.",
        date: "Dec 2024",
        readTime: "5 min read",
        href: "#",
    },
];

function Blog() {
    useEffect(() => { document.title = "Engineering Notes — Raviraj Kumar Tiwari"; }, []);

    return (
        <div className="min-h-screen" style={{ background: "var(--clr-surface)" }}>
            {/* Page Header */}
            <section className="px-6 py-20 section-light">
                <div className="max-w-6xl mx-auto">
                    <p className="section-label mb-4">Writing</p>
                    <h1 className="display-heading max-w-xl">Engineering Notes</h1>
                    <p className="mt-4 text-on-surface-variant max-w-2xl leading-relaxed">
                        Technical notes on cloud monitoring, Azure observability, and infrastructure
                        engineering — written from day-to-day practical experience.
                    </p>
                </div>
            </section>

            {/* Articles */}
            <section className="px-6 py-20" style={{ background: "var(--clr-surface)" }}>
                <div className="max-w-4xl mx-auto space-y-5">
                    {ARTICLES.map(({ id, tag, title, excerpt, date, readTime, href }) => (
                        <a
                            key={id}
                            href={href}
                            className="card-node block group"
                            style={{ background: "var(--clr-surface-lowest)" }}
                            aria-label={title}
                        >
                            <div className="flex items-start justify-between gap-4">
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-3 mb-3">
                                        <span className="chip chip-primary">{tag}</span>
                                        <span className="text-xs text-on-surface-variant">{date} · {readTime}</span>
                                    </div>
                                    <h2 className="text-base font-semibold text-on-surface group-hover:text-primary transition-colors leading-snug mb-3">
                                        {title}
                                    </h2>
                                    <p className="text-sm text-on-surface-variant leading-relaxed line-clamp-2">
                                        {excerpt}
                                    </p>
                                </div>
                                <MdArrowOutward
                                    size={18}
                                    className="flex-shrink-0 mt-1 text-on-surface-variant group-hover:text-primary transition-colors"
                                />
                            </div>
                        </a>
                    ))}
                </div>
            </section>

            {/* Note */}
            <section className="px-6 py-14 section-container">
                <div className="max-w-4xl mx-auto">
                    <div
                        className="rounded-card p-6 flex gap-4"
                        style={{ background: "color-mix(in srgb, var(--clr-primary) 8%, transparent)" }}
                    >
                        <span className="text-2xl" aria-hidden="true">✍</span>
                        <div>
                            <p className="text-sm font-medium text-on-surface mb-1">
                                Articles coming soon
                            </p>
                            <p className="text-sm text-on-surface-variant leading-relaxed">
                                These articles are being drafted based on day-to-day learnings in Azure cloud
                                monitoring and infrastructure engineering. Subscribe or check back soon.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Blog;
